import React from "react";

function LeftSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="58"
      height="58"
      fill="none"
      viewBox="0 0 58 58"
    >
      <rect
        width="55"
        height="55"
        x="1.5"
        y="-1.5"
        fill="#374151"
        rx="27.5"
        transform="matrix(-1 0 0 1 58 3)"
      ></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M32 35l-6-6 6-6"
      ></path>
      <rect
        width="55"
        height="55"
        x="1.5"
        y="-1.5"
        stroke="#4B5563"
        strokeWidth="3"
        rx="27.5"
        transform="matrix(-1 0 0 1 58 3)"
      ></rect>
    </svg>
  );
}

export default LeftSvg;
